import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTheme } from '../../contexts/ThemeContext';
import { ThemeId } from '../../styles/themes';
import ThemePickerGrid from './ThemePickerGrid';

const ThemeWelcomeModal: React.FC = () => {
  const { showWelcomeModal, themeId, previewTheme, markThemeAsSelected, setShowWelcomeModal, availableThemes } =
    useTheme();

  const handleSelect = (id: ThemeId) => previewTheme(id);

  const handleContinue = () => {
    markThemeAsSelected();
  };

  const handleLater = () => {
    setShowWelcomeModal(false);
    markThemeAsSelected();
  };

  return (
    <AnimatePresence>
      {showWelcomeModal && (
        <motion.div
          className="theme-modal-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          style={{ zIndex: 10000 }}
        >
          <motion.div
            className="theme-modal theme-modal--welcome glow-card"
            initial={{ scale: 0.92, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.92, opacity: 0 }}
          >
            <h2 className="theme-modal__title">Tema seçin</h2>
            <p className="theme-modal__subtitle">
              Siteye hoş geldiniz. Önizlemeyi tıklayarak deneyin; istediğiniz zaman header’dan değiştirebilirsiniz.
            </p>
            <ThemePickerGrid themes={availableThemes} selectedId={themeId} onSelect={handleSelect} />
            <div className="theme-modal__actions">
              <motion.button type="button" className="theme-modal__btn theme-modal__btn--primary" onClick={handleContinue} whileTap={{ scale: 0.98 }}>
                Devam et
              </motion.button>
              <motion.button type="button" className="theme-modal__btn theme-modal__btn--ghost" onClick={handleLater} whileTap={{ scale: 0.98 }}>
                Varsayılan ile devam
              </motion.button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ThemeWelcomeModal;
